import _convertToPlainText from "../quill/convertToPlainText.js";
const convertToPlainText = _convertToPlainText;
export default (function getDurationByCps(event, cps = 20) {
  let totalChars = convertToPlainText(event.text, " ").length;
  return totalChars / cps;
});